// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3QoKZ","Label":"Input_Label__2Ynvs","InputElement":"Input_InputElement__1gtxW","Invalid":"Input_Invalid__1sMbG"};